import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ink-800 text-bone-50">
        <div className="text-center">
          <div className="inline-block h-8 w-8 border-2 border-gold-500 border-t-transparent rounded-full animate-spin" />
          <p className="mt-4 uppercase tracking-[0.2em] text-xs text-bone-100/70">Verifying session…</p>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
